module.exports = __webpack_public_path__ + "02_very_short_gold.225f6687.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/02_very_short_gold.png
// module id = 4m1k
// module chunks = 0